import React, { useState, useEffect, useContext } from 'react';
import {WebContext} from '../webcontext';

import IcecastMetadataPlayer from "icecast-metadata-player";

import {postApi} from '../utils/functions';

export default function WebPlayer() {
  const service = useContext(WebContext);
  //console.log(service);

  const [isPlaying, setPlaying] = useState(false);
    
  const [player, setPlayer] = useState(undefined);
  useEffect(() => {
    const icePlayer = new IcecastMetadataPlayer('https://manager.conceptradio.fr:1530/stream', {
      onStream: (value) => {
        //console.log(value);
      },
      onMetadata: (value) => {
        //console.log(value)
      },
      metadataTypes: ["ogg"]
    });
    setPlayer(icePlayer);
  }, []);

  const [metaData, setMetaData] = useState(null);
  useEffect(() =>{

    async function x() {
      let response = await fetch('https://manager.conceptradio.fr:1530/status-json.xsl');
      let result = await response.json();
      //console.log(result.icestats);

      //let meta = metaData;
      //meta.listeners = result.icestats.source.listeners;
      setMetaData({
        title: result.icestats.source.title || '',
        artist: result.icestats.source.artist || '',
        listeners: result.icestats.source.listeners
      });

      response = null;
      result = null;
    }

    let interval = setInterval(async () => {
      x();

    }, (1000 * 20));
    x();
    //destroy interval on unmount
    return () => clearInterval(interval)
  }, [])

  const [stage, setStage] = useState({});
  useEffect(() => {
    async function getIndex() {
      let params = new URLSearchParams();
      params.append('service', 1001);
      let x = await postApi('https://api.ultrastream.io/v3/service/overview', params);
      //console.log(x.data);
      setStage(x.data.stage);
      x = null;
    }
    getIndex();

    const intervalId = setInterval(() => getIndex(), 60000);
    return ()=>clearInterval(intervalId);

  }, []);


  async function play() {
    if( isPlaying ) {
      await player.stop();
      setPlaying(false);
    } else {
      await player.play();
      setPlaying(true);
    }
    //console.log(icePlayer.metadataQueue)
    
  }

  
switch(service.web?.service.template) {
    case 2:
      return (
        <>
          <button className="player-btn" title="Play" onClick={()=>play()}>
            {isPlaying ?
              <i className="fas fa-pause" id="icon-pause" />
            :
              <i className="fas fa-play" id="icon-play" />
            }
          </button>
          <input type="range" className="player-volume" min="0" max="100" x-model="volume" />
          <span className="player-live-dot"></span>
            
          <span className="player-label" x-text="playing ? 'LIVE' : 'LISTEN LIVE'">LISTEN LIVE</span>
          <span className="player-bar-sep">|</span>
          <span className="player-now-playing">
            <span className="player-now-time" data-uk-hour="14" data-uk-end-hour="16" data-uk-day="4">14:00 - 16:00</span>
            <span className="player-now-dj">DJ Name</span>
            <span className="player-now-mix">DJ Showname</span>
          </span>
          <audio id="myAudio" ontimeupdate="onTimeUpdate()">
            <source id="source-audio" src="https://demo.ovatheme.com/podover/wp-content/uploads/2022/05/Audio-Layer.mp3" type="audio/mpeg" />
          </audio>
        </>
      )
    case 1:
      return (
        <div className="audio-onetime-player pt-sm-0 pt-5 whitebg overflow-visible">
          <div className="container">
            <div className="cmn-playerwrap">
              <audio id="myAudio" ontimeupdate="onTimeUpdate()">
                <source id="source-audio" src="https://demo.ovatheme.com/podover/wp-content/uploads/2022/05/Audio-Layer.mp3" type="audio/mpeg" />
              </audio>
              <div className="player-ctn d-flex flex-md-nowrap flex-wrap align-items-center justify-content-center gap-xxl-8 gap-xl-4 gap-3 py-xxl-7 py-xl-5 py-lg-3 py-3 px-2">
                <div className="title-audio-adjust d-flex align-items-center justify-content-md-start justify-content-center gap-xxl-8 gap-xl-4 gap-3 pe-xxl-8 pe-xl-6 pe-lg-5 pe-4">
                  <div className="btn-action theme-bg theme-circle-audio" onClick={()=>play()}>
                    <div id="btn-faws-play-pause">
                      {isPlaying ?
                        <i className="fas fa-pause" id="icon-pause" />
                      :
                        <i className="fas fa-play" id="icon-play" />
                      }
                    </div>
                  </div>
                  <div className="audio-cmn-title">
                    <div className="black-clr d-block fs20 fw-700 body-font">
                      {metaData?.artist ? `${metaData?.artist} - ` : ''} {metaData?.title}
                    </div>
                    <span className="episode-sri d-flex align-items-center gap-2 pra-clr position-relative">
                      Track Title
                      <span className="vdot"></span>
                      <span className="pra-clr">
                        0:00
                      </span>
                      
                    </span>
                    <span className="pra-clr">
                      {metaData?.listeners} Listeners
                    </span>
                  </div>
                </div>
                <div className="btn-ctn right-adjustment">
                  <div className="btn-action first-btn d-none" onclick="previous()">
                    <div id="btn-faws-back">
                      <i className="fas fa-step-backward"></i>
                    </div>
                  </div>
                  <div className="btn-action d-none" onclick="next()">
                    <div id="btn-faws-next">
                      <i className="fas fa-step-forward"></i>
                    </div>
                  </div>
                  <div id="myProgress">
                    <div id="myBar"></div>
                  </div>
                  <div className="infos-ctn ps-2">
                    <div className="timer minutes-clr fs14">00:00</div>
                    <div className="title d-none aos-init aos-animate" data-aos="zoom-in" data-aos-duration="2000">Artist 1 - audio 1</div>
                    <span className="ps-3 minutes-clr">/</span>
                    <div className="duration minutes-clr fs14">00:00</div>
                  </div>
                  {/*<div className="btn-mute ps-xxl-8 ps-xl-4 ps-3" id="toggleMute" onclick="toggleMute()">
                    <div id="btn-faws-volume">
                      <i id="icon-vol-up" className="fas fa-volume-up"></i>
                      <i id="icon-vol-mute" className="fas fa-volume-mute" ></i>
                    </div>
                  </div>*/}
                </div>
                <div className="playlist-ctn d-none"><div className="playlist-track-ctn" id="ptc-0" data-index="0"><div className="playlist-btn-play" id="pbp-0"><i className="fas fa-play" height="40" width="40" id="p-img-0"></i></div><div className="playlist-info-track">Artist 1 - audio 1</div><div className="playlist-duration">08:47</div></div><div className="playlist-track-ctn" id="ptc-1" data-index="1"><div className="playlist-btn-play" id="pbp-1"><i className="fas fa-play" height="40" width="40" id="p-img-1"></i></div><div className="playlist-info-track">Artist 2 - audio 2</div><div className="playlist-duration">05:53</div></div><div className="playlist-track-ctn" id="ptc-2" data-index="2"><div className="playlist-btn-play" id="pbp-2"><i className="fas fa-play" height="40" width="40" id="p-img-2"></i></div><div className="playlist-info-track">Artist 3 - audio 3</div><div className="playlist-duration">00:27</div></div></div>
              </div>
            </div>
          </div>
        </div>
      )
    default:
      return (<></>)
  }
}